<template>
  <div class="page-rnr-main-card component-vin-scan">
    <div class="page-rnr-person-card-car" />
    <ErrorWrap :error-message="errorMessage" :error="!!errorMessage">
      <van-field
        v-model="vin"
        :clearable="true"
        clear-trigger="always"
        label="VIN码"
        maxlength="17"
        placeholder="请输入"
        input-align="right"
        @input="handleVinInput(vin)"
        @blur="validateVin(vin)"
      />
    </ErrorWrap>
    <van-button v-if="!hideScan && isInApp" class="page-rnr-btn" plain hairline round block color="#000" @click="handleScanCode"><i class="imageicon imageicon-scan" style="filter: grayscale(100%);" />扫码添加</van-button>
  </div>
</template>

<script>
import JsBridge, { isInApp } from '@/utils/bridge'
import ErrorWrap from './ErrorWrap'

// vin码长度
const VIN_LENGTH = 17

export default {
  name: 'VinScan',
  components: { ErrorWrap },
  props: {
    hideScan: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      vinValue: '',
      errorMessage: '',
      isInApp
    }
  },
  computed: {
    // 小写自动转大写
    vin: {
      get() {
        return this.vinValue
      },
      set(val) {
        this.vinValue = val.toUpperCase()
      }
    }
  },
  activated() {
    const { vin } = this.$store.getters.loginUser
    if (vin) {
      this.validateVin(vin)
      if (!this.errorMessage) {
        this.vin = vin
        this.handleVinInput(vin)
      }
    }
  },
  methods: {
    /**
     * 开始扫码
     * 20221020：对奔驰来说，扫的是包含JSON数据的二维码。数据结构如下：
     * {
     *  "VIN":"LE4ZG8DB9****8917",
     *  "salutation":"先生",
     *  "firstName":"名字",
     *  "lastName1":"姓",
     *  "idCardNumber":"4127****9512282979",
     *  "mobilePhone":"+86187****1821",
     *  "Address":{
     *    "province":"河南省",
     *    "city":"郑州市",
     *    "district":"中原区",
     *    "street":"1",
     *    "streetNo":"2",
     *    "roomNo":"",
     *    "zip":"450000"
     *  }
     * }
     */
    handleScanCode() {
      JsBridge.scanCode(true, scanResult => {
        let vin = scanResult
        let resultData = null
        if (scanResult.length > 0 && scanResult[0] === '{') {
          try {
            const resultJson = JSON.parse(scanResult)
            console.log('resultJson', resultJson)
            // 简单处理一下数据结构，适配后台接口
            resultData = { ...resultJson, ...resultJson.Address }
            resultData.lastName = resultData.lastName1
            resultData.vin = resultData.VIN
            delete resultData.lastName1
            delete resultData.VIN
            delete resultData.Address
            vin = resultData.vin
          } catch (e) {
            console.log(e)
          }
        }
        console.log('vin', vin)
        // 校验数据
        this.validateVin(vin)
        console.log('vin1', vin)
        // 如果当前没有错误信息
        if (!this.errorMessage) {
          // 记录当前vin
          this.vin = vin
          // 开始同步给父组件
          this.handleVinInput(vin, resultData)
        }
      })
    },

    /**
     * vin输入的方法，当输入是17位，则触发change方法
     */
    handleVinInput(vin, scanResult) {
      // 如果当前输入的vin不是17位
      if (vin.length !== VIN_LENGTH || !/^([0-9]|[a-z]|[A-Z]){17}$/.test(vin)) {
        return
      }
      // 触发变更方法
      this.$emit('change', vin, scanResult)
    },

    /**
     * 校验vin码
     * @param vin 当前vin码
     */
    validateVin(vin) {
      // 如果没有输入vin码，或者vin码不合法
      if (!vin) {
        this.errorMessage = '请输入VIN码'
      } else if (vin.length !== VIN_LENGTH || !/^([0-9]|[a-z]|[A-Z]){17}$/.test(vin)) {
        // 如果没有输入vin码，或者vin码不合法
        this.errorMessage = '请输入正确的VIN码,17位字母与数字组合'
      } else {
        this.errorMessage = ''
      }
    }
  }
}
</script>

<style lang="scss">
.component-vin-scan {
  padding-bottom: 36px !important;
  .page-rnr-person-card-car {
    background-image: url(../assets/rnr/ico_car.png);
    background-repeat: no-repeat;
    background-size: 360px 184px;
    background-position: top 40px center;
    width: 360px;
    height: 232px;
    margin: 0 auto;
  }
  .page-rnr-btn {
    margin-top: 24px;
    .imageicon {
      margin-bottom: -6px;
      margin-right: 12px;
    }
  }
  .van-field {
    .van-field__label {
      width: 120px;
    }
    .van-icon-clear {
      padding: 0 14px;
      margin-left: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VinScan.vue